import {
  CHILD_BEHAVIOR_ISSUES_SCHEMA,
  hasChildBackgroundErrors,
  hasChildScheduleErrors,
} from '../../../../common';

import type { ITreatmentPlanV3ChildPage } from '../../../../../store/treatmentPlanV3';

export function hasChildFormErrors(page: ITreatmentPlanV3ChildPage) {
  return (
    hasChildBackgroundErrors(page) ||
    hasChildScheduleErrors(page, page.not_attending_school) ||
    !CHILD_BEHAVIOR_ISSUES_SCHEMA.isValidSync({
      child_behavior_issues: page.child_behavior_issues ?? '',
    })
  );
}
